(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2528],{

/***/ 56794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Authors; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function Authors(param1) {
    var people = param1.people, _expand = param1.expand, expand = _expand === void 0 ? true : _expand, _showTitle = param1.showTitle, showTitle = _showTitle === void 0 ? false : _showTitle;
    return people.map(function(param, index) {
        var name = param.name, image = param.photo, title = param.title;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('relative z-10 inline-flex items-center', {
                'mx-3': expand,
                'ml-[-16px]': !expand
            }),
            children: [
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('inline-flex rounded-full border-2 border-white bg-gray-200', {
                        'mr-3': expand
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        src: image.url,
                        title: name,
                        alt: name,
                        width: 36,
                        height: 36,
                        objectFit: "cover",
                        className: "flex rounded-full"
                    })
                }),
                expand && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-sm md:text-base",
                    children: [
                        name,
                        showTitle && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "block text-xs font-bold uppercase text-cornflower",
                            children: title
                        })
                    ]
                })
            ]
        }, index);
    });
};


/***/ }),

/***/ 79506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function Pill(param) {
    var className = param.className, _colour = param.colour, colour = _colour === void 0 ? 'pink' : _colour, label = param.label, _size = param.size, size = _size === void 0 ? 'regular' : _size;
    var colourClass = function(colourParam) {
        switch(colourParam.toUpperCase()){
            case 'BLACK':
                return 'bg-haiti text-white';
            case 'DARK_BLUE':
                return 'bg-zodiac text-white';
            case 'PINK':
                return 'bg-lavender-blush text-rose';
            default:
                return 'bg-rose text-white';
            case 'PURPLE':
                return 'bg-faded-cornflower text-cornflower';
        }
    };
    var sizeClass = function(sizeParam) {
        switch(sizeParam){
            case 'small':
                return 'px-1 rounded-sm text-xxs';
            case 'large':
                return 'md:text-base px-2 py-1 rounded text-sm';
            case 'regular':
            default:
                return 'px-2 py-1 rounded text-xs';
        }
    };
    var labelClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()('font-medium mx-1 my-1', className, colourClass(colour), sizeClass(size));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: labelClass,
        children: label
    }));
};


/***/ }),

/***/ 74680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SliderItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51188);



function SliderItem(param) {
    var Component = param.Component, _withOverflowHidden = param.withOverflowHidden, withOverflowHidden = _withOverflowHidden === void 0 ? true : _withOverflowHidden;
    var items = (0,_context__WEBPACK_IMPORTED_MODULE_2__/* .useSliderState */ .xu)().items;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("rounded-lg bg-whisper shadow-lg md:flex", withOverflowHidden && "overflow-hidden"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            items: items
        })
    }));
};


/***/ }),

/***/ 51188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YO": function() { return /* binding */ SliderProvider; },
/* harmony export */   "xu": function() { return /* binding */ useSliderState; },
/* harmony export */   "g9": function() { return /* binding */ useSliderDispatch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SliderStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var SliderDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
function next(param) {
    var length = param.length, current = param.current;
    return (current + 1) % length;
}
function previous(param) {
    var length = param.length, current = param.current;
    return (current - 1 + length) % length;
}
function reducer(state, param) {
    var type = param.type, index = param.index;
    switch(type){
        case "NEXT":
            return _objectSpread({}, state, {
                activeIndex: next({
                    length: state.length,
                    current: state.activeIndex
                })
            });
        case "PREVIOUS":
            return _objectSpread({}, state, {
                activeIndex: previous({
                    length: state.length,
                    current: state.activeIndex
                })
            });
        case "CUSTOM":
            return _objectSpread({}, state, {
                activeIndex: index || 0
            });
        default:
            throw new Error("Invalid action: ".concat(type));
    }
}
function SliderProvider(param) {
    var children = param.children, _items = param.items, items = _items === void 0 ? [] : _items;
    var nextItem = function nextItem() {
        dispatch({
            type: "NEXT"
        });
    };
    var previousItem = function previousItem() {
        dispatch({
            type: "PREVIOUS"
        });
    };
    var goToItem = function goToItem(index) {
        dispatch({
            type: "CUSTOM",
            index: index
        });
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, {
        length: items.length,
        activeIndex: 0
    }), state = ref[0], dispatch = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(items[0]), activeItem = ref1[0], setActiveItem = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setActiveItem(items[state.activeIndex]);
    }, [
        items,
        state.activeIndex
    ]);
    var isFirstItemActive = items.indexOf(activeItem) === 0;
    var isLastItemActive = items.indexOf(activeItem) + 1 === state.length;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderStateContext.Provider, {
        value: _objectSpread({}, state, {
            activeItem: activeItem,
            isFirstItemActive: isFirstItemActive,
            isLastItemActive: isLastItemActive,
            items: items
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderDispatchContext.Provider, {
            value: {
                dispatch: dispatch,
                nextItem: nextItem,
                previousItem: previousItem,
                goToItem: goToItem
            },
            children: children
        })
    }));
}
function useSliderState() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SliderStateContext);
    if (!context) throw new Error("useSliderState must be used within a SliderProvider");
    return context;
}
function useSliderDispatch() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SliderDispatchContext);
    if (!context) throw new Error("useSliderDispatch must be used within a SliderProvider");
    return context;
}



/***/ }),

/***/ 71839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Slider/context.tsx
var context = __webpack_require__(51188);
// EXTERNAL MODULE: ./src/components/Slider/Item.tsx
var Item = __webpack_require__(74680);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/Slider/Nav.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function NavButton(_param) {
    var className = _param.className, _dir = _param.dir, dir = _dir === void 0 ? "next" : _dir, disabled = _param.disabled, props = _objectWithoutProperties(_param, [
        "className",
        "dir",
        "disabled"
    ]);
    var nextButton = dir === "next";
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", _objectSpread({
        type: "button",
        className: classnames_default()("rounded bg-white px-4 shadow-sm transition-transform duration-75", className, {
            'hover:translate-x-1': nextButton,
            'hover:-translate-x-1': !nextButton,
            'transform hover:text-cornflower': !disabled,
            'cursor-not-allowed opacity-50': disabled
        })
    }, props, {
        children: nextButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "→"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "←"
        })
    })));
}
function SliderNav() {
    var ref = (0,context/* useSliderDispatch */.g9)(), nextItem = ref.nextItem, previousItem = ref.previousItem;
    var ref1 = (0,context/* useSliderState */.xu)(), isFirstItemActive = ref1.isFirstItemActive, isLastItemActive = ref1.isLastItemActive;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right-full order-1 px-0 lg:absolute lg:px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButton, _objectSpread({
                    dir: "previous"
                }, !isFirstItemActive && {
                    onClick: previousItem
                }, {
                    disabled: isFirstItemActive
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left-full order-3 px-0 lg:absolute lg:px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButton, _objectSpread({
                    dir: "next"
                }, !isLastItemActive && {
                    onClick: nextItem
                }, {
                    disabled: isLastItemActive
                }))
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/Slider/index.tsx




function Slider(param) {
    var Component = param.Component, items = param.items, withOverflowHidden = param.withOverflowHidden;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(context/* SliderProvider */.YO, {
        items: items,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex flex-wrap items-center justify-between lg:-mx-3 lg:flex-nowrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-6 w-full lg:order-2 lg:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        Component: Component,
                        withOverflowHidden: withOverflowHidden
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderNav, {})
            ]
        })
    }));
};


/***/ }),

/***/ 44497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scroll; },
/* harmony export */   "X": function() { return /* binding */ scrollTo; }
/* harmony export */ });
/* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30523);
/* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_0__);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var installed = false;
var scroll = function(options) {
    if (!installed) {
        try {
            smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_0___default().polyfill();
        } catch (err) {
            console.error("smoothscroll polyfill failed", err);
            return;
        }
        installed = true;
    }
    try {
        window.scroll(_objectSpread({
            behavior: "smooth"
        }, options));
    } catch (err) {
        console.error("smoothscroll polyfill failed", err);
    }
};
var scrollTo = function(el) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (el.current) {
        scroll({
            top: el.current.offsetTop + offset
        });
    }
};


/***/ }),

/***/ 70507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; },
/* harmony export */   "U": function() { return /* binding */ useButton; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17167);
/* harmony import */ var reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11574);
/* harmony import */ var reakit_system_createHook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23543);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var reakit_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49412);
/* harmony import */ var reakit_utils_isButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37793);
/* harmony import */ var reakit_warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91791);
/* harmony import */ var _Clickable_Clickable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79639);



















// Automatically generated
var BUTTON_KEYS = [];

var useButton = (0,reakit_system_createHook__WEBPACK_IMPORTED_MODULE_2__/* .createHook */ .B)({
  name: "Button",
  compose: _Clickable_Clickable_js__WEBPACK_IMPORTED_MODULE_3__/* .useClickable */ .h,
  keys: BUTTON_KEYS,
  useProps: function useProps(_, _ref) {
    var htmlRef = _ref.ref,
        htmlProps = (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__._)(_ref, ["ref"]);

    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

    var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined),
        role = _React$useState[0],
        setRole = _React$useState[1];

    var _React$useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("button"),
        type = _React$useState2[0],
        setType = _React$useState2[1];

    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
      var element = ref.current;

      if (!element) {
         false ? 0 : void 0;
        return;
      }

      if (!(0,reakit_utils_isButton__WEBPACK_IMPORTED_MODULE_5__/* .isButton */ .i)(element)) {
        if (element.tagName !== "A") {
          setRole("button");
        }

        setType(undefined);
      }
    }, []);
    return (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__.a)({
      ref: (0,reakit_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* .useForkRef */ .c)(ref, htmlRef),
      role: role,
      type: type
    }, htmlProps);
  }
});
var Button = (0,reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_7__/* .createComponent */ .L)({
  as: "button",
  memo: true,
  useHook: useButton
});




/***/ }),

/***/ 30523:
/***/ (function(module) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ })

}]);